<div ng-controller="purgeDocumentsController as ctrl" class="modal-view purge-documents">
    <div class="purge-menu">
        <h1>{{'admin.workflows.purge.header'|translate}}</h1>

        <ul class="button-widgets">
            <li ng-click="ctrl.goto('admin.purgeViaTags')"><span>{{'admin.workflows.purge.viaTags'|translate}}</span></li>
            <li ng-click="ctrl.goto('admin.purgeViaRegno')"><span>{{'admin.workflows.purge.viaRegno'|translate}}</span></li>
        </ul>
    </div>
</div>